import { useTranslation } from "react-i18next";
import { Container, Typography, Box } from "@mui/material";
import Header from "../components/Header";
import Footer from "../components/Footer";

const ReturnRefundPolicy = () => {
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h4"  style={{   color: "#00704A", borderBottom: "2px solid #EEE", paddingBottom: 1}} gutterBottom>
          {t("return_refund_intro_title")}
        </Typography>
            <Typography variant="body1" paragraph>
                <strong> {t("effective_date")} </strong> 4th December 2025
              </Typography>
        {/* Intro */}
        <Typography paragraph>{t("return_refund_intro_1")}</Typography>
        <Typography paragraph>{t("return_refund_intro_2")}</Typography>
        <Typography paragraph>{t("return_refund_intro_3")}</Typography>

        {/* Section 1 */}
        <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
          {t("return_policy_title")}
        </Typography>

        <Typography paragraph>{t("return_policy_1")}</Typography>
        <Typography paragraph>{t("return_policy_2")}</Typography>
        <Typography paragraph>{t("return_policy_3")}</Typography>
        <Typography paragraph>{t("return_policy_4")}</Typography>
        <Typography paragraph>{t("return_policy_5")}</Typography>

        <ul>
          <li>{t("return_conditions_1")}</li>
          <li>{t("return_conditions_2")}</li>
          <li>{t("return_conditions_3")}</li>
          <li>{t("return_conditions_4")}</li>
          <li>{t("return_conditions_6")}</li>
        </ul>

        {/* Return procedure */}
        <Typography paragraph>{t("return_procedure_1")}</Typography>
        <ul>
                               
         <li>{t("return_procedure_2")}</li>
          <li>{t("return_procedure_3")}</li>
          <li>{t("return_procedure_4")}</li>
          <li>{t("return_procedure_5")}</li>
          <li>{t("return_procedure_6")}</li>
        </ul>

                 <Typography paragraph>{t("return_procedure_6_7")}</Typography>
        {/* Not eligible */}
        <Typography paragraph>{t("return_not_eligible_1")}</Typography>
        <ul>
          <li>{t("return_not_eligible_2")}</li>
          <li>{t("return_not_eligible_3")}</li>
          <li>{t("return_not_eligible_4")}</li>
          <li>{t("return_not_eligible_5")}</li>
          <li>{t("return_not_eligible_6")}</li>
        </ul>

        <Typography paragraph>{t("return_policy_warning")}</Typography>

        {/* Section 2 */}
        <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
          {t("refund_policy_title")}
        </Typography>

        <Typography paragraph>{t("refund_policy_1")}</Typography>
        <Typography paragraph>{t("refund_policy_2")}</Typography>
        <Typography paragraph>{t("refund_policy_3")}</Typography>
        <Typography paragraph>{t("refund_policy_4")}</Typography>
        <Typography paragraph>{t("refund_policy_5")}</Typography>

        {/* Contact */}
        <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
          {t("contact_us_title")}
        </Typography>

        <Typography paragraph>{t("contact_us_1")}</Typography>
        <Typography paragraph>{t("contact_us_2")}</Typography>
        <Typography paragraph>{t("contact_us_3")}</Typography>
          <Typography paragraph>{t("contact_us_number")}</Typography>
          <Typography paragraph>{t("contact_us_email")}</Typography>
      </Container>
      <Footer />
    </>
  );
};

export default ReturnRefundPolicy;
